package com.kinoshazam.uiKit.components.cells.cellItem

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.kinoshazam.uiKit.components.textLabel.TextLabel

@Composable
fun CellItem(
    state: CellItemState,
    modifier: Modifier = Modifier,
) {
    Row {
        TextLabel(
            state = state.title,
            modifier = modifier.weight(1f).padding(16.dp)
        )

        state.value?.let { value ->
            TextLabel(
                modifier = modifier.padding(),
                state = value,
            )
        }
    }
}

